/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-08-29 13:59:49
 * @FilePath: \crane-safety-manager\src\slices\sites\thunk.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

import { APIClient } from '../../helpers/api_helper';
import * as ToastHelper from '../../helpers/toast_helper';

const prefix = 'site';
const tname = '工地';

export const getAll = createAsyncThunk(`${prefix}/get-all`, async function (projectId) {
    const params = {};
    if (!_.isEmpty(projectId)) {
        params['projectId'] = projectId;
    }
    const { data } = await APIClient.get('/sites', { params });
    return data;
});

export const create = createAsyncThunk(`${prefix}/create`, async function (payload) {
    try {
        const response = await APIClient.post('/sites', payload);
        ToastHelper.createSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.createFailed(tname);
        throw error;
    }
});

export const update = createAsyncThunk(`${prefix}/update`, async function (payload) {
    try {
        const response = await APIClient.put(`/sites/${payload.id}`, payload);
        ToastHelper.updateSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.updateFailed(tname);
        throw error;
    }
});

export const remove = createAsyncThunk(`${prefix}/remove`, async function (id) {
    try {
        await APIClient.delete(`/sites/${id}`);
        ToastHelper.removeSucceeded(tname);
        return id;
    } catch (error) {
        var tnames = tname;
        if (error.response.data.includes('foreign key constraint')) {
            tnames = '工地下存在关联车辆，删除';
        }
        ToastHelper.removeFailed(tnames);
        throw error;
    }
});
